module.exports = __webpack_public_path__ + "media/images/svgs/icon-alert-0c42c0123b17fee4d77f47470a5b3047.svg";